export { EventDetails } from './EventDetails';
